






















import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  lawyerLists = [
    {
      src: require('./assets/01.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82862',
    },
    {
      src: require('./assets/02.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82788',
    },
    {
      src: require('./assets/03.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82787',
    },
    {
      src: require('./assets/04.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=82722',
    },
    {
      src: require('./assets/05.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=83063',
    },
    {
      src: require('./assets/06.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=81243',
    },
    {
      src: require('./assets/07.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=77613',
    },
    {
      src: require('./assets/08.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=73575',
    },
    {
      src: require('./assets/09.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=69420',
    },
    {
      src: require('./assets/10.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=63307',
    },
    {
      src: require('./assets/11.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=20354',
    },
    {
      src: require('./assets/12.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=15264',
    },
    {
      src: require('./assets/13.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=15263',
    },
    {
      src: require('./assets/14.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=2593',
    },
    {
      src: require('./assets/15.png'),
      target: 'https://wap.cqcb.com/shangyou_news/BangBang/QA/list?id=81119',
    },
  ];

  created() {
    // 分享
    this.$appShareInfo({
      title: '上游新闻@你：你知道工伤的打开方式有哪些吗？',
      url: window.location.href,
      subtitle: '上游新闻帮帮律师团，为您提供“专属”法律服务',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    this.$wxShareInfo({
      title: '上游新闻@你：你知道工伤的打开方式有哪些吗？',
      subtitle: '上游新闻帮帮律师团，为您提供“专属”法律服务',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  onNavTo(person: any) {
    // window.open(person.target);
    window.location.href = person.target;
  }
}
